import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CustomerService } from 'src/app/shared/services/customer-services/customer.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';
import {
  ViewProfileService,
} from 'src/app/shared/services/view-profile-servies/view-profile.service';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.css'],
})
export class ViewProfileComponent implements OnInit, OnDestroy {
  subMenuItems: any[] = [];
  imageBaseUrl = environment.imageBaseUrl;

  user: any | undefined;
  imageUrl: any;
  defaultImage: any = 'assets/image/profile.jpg';
  filteredSideMenu: any;
  loginUserType: any = '';
  customerId: any;
  customerProfile: any;
  count=0
  profileData:any
  private routerSubscription?: Subscription;

  constructor(
    private profileService: ViewProfileService,
    private userService: UserService,
    private readonly router: Router,
    private route: ActivatedRoute
  ) {
    this.loginUserType = this.userService.getUserRole();
    console.log('loginUserType', this.loginUserType);
  }

  ngOnInit() {
    // Setup menu items first
    this.subMenuItems = [
      {
        image: '',
        name: 'Personal Details',
        route: '/home/profile/personal-details',
        roles: ['Admin', 'Employee', 'Organization', 'Branch', 'Staff', 'User'],
      },
      {
        image: '',
        name: 'Identity Documents',
        route: '/home/profile/identity-documents',
        roles: ['Employee', 'Admin', 'Organization', 'Branch', 'Staff', 'User'],
        icon: 'badge'
      },
      // {
      //   image: '',
      //   name: 'Notification Settings',
      //   route: '/home/profile/notification-settings',
      //   roles: ['Admin', 'Employee', 'Organization', 'Branch', 'Staff', 'User'],
      // },
      {
        image: '',
        name: 'Password Manager',
        route: '/home/profile/password-manager',
        roles: ['Admin', 'Employee', 'Organization', 'Branch', 'Staff', 'User'],
      },
      // {
      //   image: '',
      //   name: 'Bank Details',
      //   route: '/home/profile/bank-details',
      //   roles: ['Employee', 'Organization', 'Branch', 'Staff', 'User', 'Admin'],
      // },
      // {
      //   image: '',
      //   name: 'KYC Manager',
      //   route: '/home/profile/kyc-details',
      //   roles: ['Employee', 'Organization', 'Branch', 'Staff', 'User', 'Admin'],
      // },
    ];

    // Extract customer ID and load profile data
    this.loadProfileData();

    // Listen to router events to catch navigation changes
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.loadProfileData();
      });

    // Filter menu using the logged-in user's role (case-insensitive)
    const currentRole = (this.loginUserType || '').toString().toLowerCase();
    console.log('currentRole', currentRole);
    this.filteredSideMenu = this.subMenuItems.filter((item) => {
      const roles = (item.roles || []).map((r: any) => r?.toString().toLowerCase());
      return roles.includes(currentRole);
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private loadProfileData(): void {
    this.extractCustomerId();
    
    // Update menu routes with customerId if available
    this.updateMenuRoutes();
    
    if (this.customerId) {
      this.getDetails(this.customerId);
    } else {
      this.profileService.getProfile().subscribe((data) => {
        this.profileData = data;
        if (data?.org_logo) {
          this.imageUrl = this.imageBaseUrl + data.org_logo;
        }
        // Only use org_id as customerId for organization accounts — staff use their own id
        const jwtType = this.userService.getJwtAccountType();
        if (!this.customerId) {
          if (jwtType === 3 || jwtType === 4) {
            this.customerId = data.id;
          } else if (jwtType === 5) {
            this.customerId = data.branch_id ?? data.id;
          } else if (data?.org_id) {
            this.customerId = data.org_id;
          }
          this.updateMenuRoutes();
        }
      });
    }
  }

  private updateMenuRoutes(): void {
    // Update menu item routes to include customerId if available
    this.subMenuItems.forEach(item => {
      if (this.customerId && item.route && !item.route.includes(this.customerId.toString())) {
        // Only update routes that don't already have an ID
        if (item.name === 'Personal Details') {
          item.route = `/home/profile/personal-details`;
        } else if (item.name === 'Notification Settings') {
          item.route = `/home/profile/notification-settings/${this.customerId}`;
        } else if (item.name === 'Bank Details') {
          item.route = `/home/profile/bank-details/${this.customerId}`;
        } else if (item.name === 'KYC Manager') {
          item.route = `/home/profile/kyc-details/${this.customerId}`;
        } else if (item.name === 'Identity Documents') {
          item.route = `/home/profile/identity-documents/${this.customerId}`;
        }
      }
    });
  }

  private extractCustomerId(): void {
    // Method 1: Check parent route params
    const parentParams = this.route.snapshot.params;
    if (parentParams && parentParams['id']) {
      this.customerId = parentParams['id'];
      console.log('ID from parent route params:', this.customerId);
      return;
    }

    // Method 2: Check child route params (most common case)
    let childRoute = this.route.snapshot.firstChild;
    while (childRoute) {
      if (childRoute.params && childRoute.params['id']) {
        this.customerId = childRoute.params['id'];
        console.log('ID from child route params:', this.customerId);
        return;
      }
      childRoute = childRoute.firstChild;
    }

    // Method 3: Extract from URL directly using regex patterns
    const url = this.router.url;
    
    // Pattern 1: /personal-details/95 or /profile/personal-details/95
    const personalDetailsMatch = url.match(/\/personal-details\/(\d+)/);
    if (personalDetailsMatch && personalDetailsMatch[1]) {
      this.customerId = personalDetailsMatch[1];
      console.log('ID from personal-details URL pattern:', this.customerId);
      return;
    }

    // Pattern 2: /profile/95 (if profile route has ID directly)
    const profileMatch = url.match(/\/profile\/(\d+)(?:\/|$)/);
    if (profileMatch && profileMatch[1]) {
      this.customerId = profileMatch[1];
      console.log('ID from profile URL pattern:', this.customerId);
      return;
    }

    // Method 4: Extract from URL parts (fallback)
    const urlParts = url.split('/').filter(part => part.length > 0);
    // Look for pattern: .../personal-details/NUMBER or .../profile/NUMBER
    for (let i = 0; i < urlParts.length - 1; i++) {
      if ((urlParts[i] === 'personal-details' || urlParts[i] === 'profile') && 
          urlParts[i + 1] && /^\d+$/.test(urlParts[i + 1])) {
        this.customerId = urlParts[i + 1];
        console.log('ID extracted from URL parts:', this.customerId);
        return;
      }
    }

    console.log('No customer ID found in URL:', url);
  }
  getDetails(id: any) {
    if (!id) {
      console.warn('No ID provided to getDetails');
      return;
    }
    console.log('Fetching profile for ID:', id);
    this.profileService.getProfileById(id).subscribe(
      (data) => {
        this.profileData = data;
        console.log('Profile data received:', this.profileData);
        if (this.profileData?.org_logo) {
          this.imageUrl = this.imageBaseUrl + this.profileData.org_logo;
        }
      },
      (error) => {
        console.error('Error fetching profile:', error);
      }
    );
  }
  
}
